// extracted by mini-css-extract-plugin
export default {"content":"Success_content__VbjeY","title":"Success_title__RUb15","description":"Success_description__BtBa9"};